export const MATCHUP_PROGRESSION_ALL_MATCHES = 0;
export const MATCHUP_PROGRESSION_BEST_OF_N = 1;
export const MATCHUP_PROGRESSION_MANUAL = 2;

type MatchupChild = {
  isTiebreaker?: boolean;
  bracketCellMatchCount?: number | null;
};

export function getMatchupCategoryCount(matches: MatchupChild[]): number {
  if (!matches.length) return 0;
  const nonDecider = matches.filter((m) => !m.isTiebreaker);
  const cellMatchCount = matches[0]?.bracketCellMatchCount ?? matches.length;
  if (matches.some((m) => m.isTiebreaker)) {
    return Math.max(nonDecider.length, cellMatchCount - 1);
  }
  if (cellMatchCount === nonDecider.length + 1) {
    return nonDecider.length;
  }
  return Math.max(nonDecider.length, cellMatchCount);
}

export function getBestOfNWinsNeeded(categoryCount: number): number {
  if (categoryCount <= 0) return 1;
  return Math.floor(categoryCount / 2) + 1;
}

export function getMatchupHasDecider(matches: MatchupChild[]): boolean {
  return matches.some((m) => m.isTiebreaker);
}

/** Label N includes the decider slot; winsNeeded still uses categoryCount. */
export function getMatchupBestOfN(categoryCount: number, hasDecider: boolean): number {
  return hasDecider ? categoryCount + 1 : categoryCount;
}

export type MatchupProgressionSummary = {
  mode: number;
  categoryCount: number;
  bestOfN: number;
  winsNeeded: number;
  hasDecider: boolean;
};

export function getMatchupProgressionSummary(
  matches: MatchupChild[],
  progressionMode: number | string | null | undefined,
): MatchupProgressionSummary {
  const categoryCount = getMatchupCategoryCount(matches);
  const hasDecider = getMatchupHasDecider(matches);
  return {
    mode: Number(progressionMode ?? MATCHUP_PROGRESSION_MANUAL),
    categoryCount,
    bestOfN: getMatchupBestOfN(categoryCount, hasDecider),
    winsNeeded: getBestOfNWinsNeeded(categoryCount),
    hasDecider,
  };
}
